import { AcModel } from "../pacts/app-webcore/hasura-webcore.graphql";

const getDisplayName = (acModel: AcModel) => {
  return `${acModel.identifier}: ${acModel.modelName} ${acModel.brandName}`;
};

export default {
  getDisplayName,
};
